import React from 'react';
import LegacyTextRenderer from './LegacyTextRenderer';
import BaseViewer from '../DaEditorWrapper/Viewer/Base';
import ErrorBoundary from '../ErrorBoundary';
export var TextRenderer = function (_a) {
    var textContent = _a.textContent, className = _a.className, _b = _a.fallbackToExcerpt, fallbackToExcerpt = _b === void 0 ? true : _b, reactViewer = _a.reactViewer, htmlExcerptLegacy = _a.htmlExcerptLegacy, isPollWithHtmlExcerpt = _a.isPollWithHtmlExcerpt, width = _a.width, legacyTheme = _a.legacyTheme, excerptOnly = _a.excerptOnly;
    if (!textContent) {
        return null;
    }
    var markup = textContent.html && textContent.html.markup;
    if (!markup || excerptOnly) {
        if (!fallbackToExcerpt) {
            return null;
        }
        if (htmlExcerptLegacy && textContent.html.type === 'writer') {
            return (React.createElement(LegacyTextRenderer, { className: className, html: textContent.excerpt, theme: legacyTheme }));
        }
        if (isPollWithHtmlExcerpt &&
            textContent.html.type === 'draft' &&
            textContent.excerpt.trim().length > 0) {
            return (React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: textContent.excerpt } }));
        }
        return React.createElement("div", { className: className }, textContent.excerpt);
    }
    switch (textContent.html.type) {
        case 'writer':
            return (React.createElement(WrapWidth, { width: width },
                React.createElement(LegacyTextRenderer, { className: className, html: markup, theme: legacyTheme })));
        case 'draft':
            var Viewer = reactViewer || BaseViewer;
            try {
                return (React.createElement(ErrorBoundary, null,
                    React.createElement(WrapWidth, { width: width },
                        React.createElement("div", { className: className },
                            React.createElement(Viewer, { content: JSON.parse(markup) })))));
            }
            catch (e) {
                return null;
            }
        default:
            return null;
    }
};
TextRenderer.displayName = 'TextRenderer';
var WrapWidth = function (_a) {
    var width = _a.width, children = _a.children;
    if (!width) {
        return children;
    }
    return React.createElement("div", { style: { width: width } }, children);
};
WrapWidth.displayName = 'WrapWidth';
export default TextRenderer;
//# sourceMappingURL=TextRenderer.js.map